import Lng from "../3x1010/Lng.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";
import { SecurityAcl, SecurityAclContext, AuthCheckAcl } from "../Security.js";
import SiteHeader from "../components/common/header/SiteHeader.component.js";
import VirtualList from "../components/common/VirtualList.component.js";

export default class PageCommon {
  constructor() {
    PageCommon.that = this;
    this.body = document.body;
    this.siteHeader;
  }

  init($data) {
    Pqp.trace("PageCommon");
    this.metaInfo = $data && $data.metaInfo ? $data.metaInfo : null;

    /**
     * PqP & Wlf methods
     * */
    this.initDefault($data);

    /**
     * layout methods setup
     * */
    this.setupCssProps();
    $data?.isAuthPage && this.initPageLoginLayout();

    /**
     * recall layout methods on resize
     * if necessary
     * */
    let debouncer;
    window.addEventListener("resize", () => {
      clearTimeout(debouncer);
      debouncer = setTimeout(() => {
        this.setupCssProps();
        $data?.isAuthPage && this.initPageLoginLayout();
      }, 250);
    });

    /**
     * components
     * */
    if ($data && $data.Header) {
      this.initSiteHeader();
      this.setFullTextSearch();
    }

    /**
     * PATCH chiusura virtualList
     * */
    document.body.addEventListener("click", (e) => {
      VirtualList.instances?.forEach(i => i.hideList());
    });

    this.checkLogin(false, null);
  }

  //
  checkLogin(bCall, rs) {
    // se sono in login non faccio nulla
    if (window.location.href.indexOf("/login") != -1) {
      this.LogiStatus = false;
      return;
    }
    //
    if (!bCall) {
      this.LogiStatus = TheApp.CurrentContext.IsAuthenticated;
      thatServiceManager.standardCall("/api/auth/logincheck", {}, this.checkLogin.bind(this, true), "GET");
    } else {
      let old = this.LogiStatus;
      // console.log(rs);
      if (rs && rs.StatusCode && rs.StatusCode == 200) {
        this.LogiStatus = rs.data;
      }
      if (old == true && this.LogiStatus == false) {
        window.location.href = "/login";
      } else {
        setTimeout(this.checkLogin.bind(this, false, null), 60000);
      }
    }
  }

  /**
   * inits site header
   * */
  initSiteHeader() {
    const header = this.body.querySelector(".js-site-header");
    const btnUserActions = header?.querySelector(".js-toggle-user-actions");
    const userActionsPanel = header?.querySelector(".js-user-actions");
    const headerSearch = header?.querySelector(".js-header-search");
    const hsCollection = header?.querySelector(".js-hs-collection");
    const hsFields = header?.querySelector(".js-hs-fields");
    const hsFullText = header?.querySelector(".js-hs-fulltext");
    const hsBtnSubmit = header?.querySelector(".js-btn-submit-search");

    if (!header) return;

    this.siteHeader = new SiteHeader({
      siteHeader: header,
      hasSimpleSearch: true,
      simpleSearchData: [],
      userActions: {
        btn: btnUserActions,
        target: userActionsPanel,
      },
      simpleSearch: {
        container: headerSearch,
        listCollection: hsCollection,
        listFields: hsFields,
        textFieldCont: hsFullText,
        btnSubmit: hsBtnSubmit
      }
    });

    this.siteHeader.init();
  }

  /**
   * sets helper layout vars in page login
   * */
  initPageLoginLayout() {
    const loginWidget = this.body.querySelector(".login-wrapper");
    loginWidget?.parentNode.style.setProperty("--offset-top", `${loginWidget?.offsetTop}px`);
  }

  /**
   * sets general but useful css props to target
   * for styling purposes
   * */
  setupCssProps() {
    const w = window.innerWidth;
    const h = window.innerHeight;
    const navH = this.body.querySelector(".js-site-header")?.offsetHeight;
    this.body.style.setProperty("--window-w", `${w}px`);
    this.body.style.setProperty("--window-h", `${h}px`);
    navH && this.body.style.setProperty("--nav-h", `${navH}px`);
  }

  /**
   * -- TR
   * robe che non conosco
   * di PqP e Wlf
   * */
  initDefault($data) {
    //
    if (this.metaInfo) {
      history.replaceState(history.state, this.metaInfo.Title, this.metaInfo.Url + location.hash);
      document.title = metaInfo.Title;
    }

    // page id
    if ($data && $data.page && $data.page.PageId) {
      let split = StateManager._splitUrl(document.location.href);
      split.qPart["_pi"] = $data.page.PageId; // page id
      delete split.qPart["__pi"]; // = canonical back page id
      let qs = "";
      for (let k in split.qPart) qs += (qs == "" ? "" : "&") + k + "=" + encodeURIComponent(split.qPart[k]);
      let u = split.url + "?" + qs + (split.Hash != "" ? split.Hash : "");
      history.replaceState(history.state /*history.state*/, document.title, u /*document.location*/);
    }
    // acl context
    this.aclContext = new SecurityAclContext(true);

    $(".js-logout").on("click", this.doLogout.bind(this));
    $(".js-alert").on("click", this.goAlert.bind(this));
    if (window.location.href.indexOf("#alert") > -1) {
      let al = $("#alert-section").offset().top;
      let alertSection = document.querySelector("#alert-section");
      if (alertSection) {
        $("body,html").animate(
          {
            scrollTop: al * 2.5,
          },
          500
        );
      }
    }

    $(".js-tab-btn").on("click", $.proxy(this.activeTab, this));
    if (TheApp.CurrentContext.userSession != null && TheApp.CurrentContext.userSession.userData != null && TheApp.CurrentContext.userSession.userData.usr != null) $(".js-headerDisplayName").html(TheApp.CurrentContext.userSession.userData.usr.DisplayName);
    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGECOMMON_INITED);
    } catch (error) {
      console.log(error);
    }
    StateManager.initialize();
    if (!Pqp.isNullOrEmpty(sessionStorage.getItem("quicksearch"))) {
      $("#dropdownsearch").val(sessionStorage.getItem("quicksearch"));
      // $('#dropdownsearch')//.find(":selected").val()
    }
    $(".jsSearchHeader").on("click", this.onSearchHeader.bind(this, false));
    $("#filtersearch").on("keyup", this.onSearchHeader.bind(this, true));
  }

  goAlert() {
    let home = document.querySelector(".home-wrapper");
    if (home) {
      let al = $("#alert-section").offset().top;
      $("body,html").animate(
        {
          scrollTop: al,
        },
        500
      );
    } else {
      window.location.href = "/#alert";
    }
  }

  doLogout() {
    AuthWiz.doLogout("/");
  }

  activeTab(e) {
    let target = e.target;
    let toggle = target.dataset.tab;
    let btnTabs = document.querySelectorAll(".js-tab-btn");
    btnTabs.forEach((el) => {
      el.classList.remove("active");
    });
    target.classList.add("active");
    let tabs = document.querySelectorAll(".single-tab");
    tabs.forEach((el) => {
      el.classList.remove("active");
    });
    let tab = document.querySelector(`.js-tab-${toggle}`);
    tab.classList.add("active");
  }

  collapseMenu() {
    $(".sidebar-menu").toggleClass("collapsed");
    $(".app-content").toggleClass("collapsed");
  }

  dispatchInitEvent(evenTyepe) {
    // dispaccio un evento globale
    let ev = new Event(evenTyepe);
    ev.payload = { page: this };
    TheDisp.dispatchEvent(ev);
  }

  get isHomepage() {
    return false;
  }

  showPreloader(flag) {
    if (flag) {
      jQuery(".js-preloader").show();
    } else {
      jQuery(".js-preloader").hide();
    }
  }

  static showPreloader(flag) {
    if (flag) {
      jQuery(".js-preloader").show();
    } else {
      jQuery(".js-preloader").hide();
    }
  }

  track() {
    if (Globals.SHOW_TRACKING_DATA) {
      console.log("---tracking---");
      console.log("Event: " + PageCommon._normalizza_track_prop(o.event));
      console.log("Category: " + PageCommon._normalizza_track_prop(o.category));
      console.log("Label: " + o.label ? PageCommon._normalizza_track_prop(o.label) : "n/a");
    }

    let additional = {
      event_category: PageCommon._normalizza_track_prop(o.category),
    };
    if (o.label) {
      additional.event_label = PageCommon._normalizza_track_prop(o.label);
    }

    gtag("event", PageCommon._normalizza_track_prop(o.event), additional);
  }

  _normalizza_track_prop(s) {
    let ret = s.toLowerCase();
    ret = Pqp.safeReplace(ret, " ", "_");
    ret = Pqp.safeReplace(ret, "'", "_");
    ret = Pqp.safeReplace(ret, ".", "");
    ret = Pqp.safeReplace(ret, ",", "");
    ret = Pqp.safeReplace(ret, "(", "_");
    ret = Pqp.safeReplace(ret, ")", "");
    ret = Pqp.safeReplace(ret, "__", "_");
    return ret;
  }

  static disable(mc, lFlag, opacity = 0.5) {
    if (lFlag) {
      mc.css("pointer-events", "none");
      mc.css("opacity", opacity);
    } else {
      mc.css("pointer-events", "all");
      mc.css("opacity", 1);
    }
  }

  headerEventHandler(e) {}

  onSearchHeader(onKyeUp, event) {
    if (onKyeUp == true) {
      if (event.keyCode != 13) return;
      event.preventDefault();
    }

    var filter = $("#filtersearch").val();
    let state = {
      p: -1, // page
      s: {}, // sort
      t: filter, // text
    };
    var sez = $("#dropdownsearch").find(":selected").val();
    sessionStorage.setItem("quicksearch", sez);
    StateManager.setViewState("jsList", state);
    let args = StateManager._splitUrl(document.location.href);
    let url = "?_vs=" + encodeURIComponent(args.qPart["_vs"]);
    document.location.href = TheApp.Env.BaseUrlNls + sez.toLowerCase() + "/" + url;
  }

  initSelectTemplate() {
    let select = $("#listtemplateexport");
    select.empty();
    let templatelist = this.data.exportlist;
    if (!Pqp.isNullOrEmpty(templatelist)) {
      $.each(templatelist, function (key, entry) {
        select.append($("<option></option>").attr("value", entry.Uid).text(entry.Label));
      });
    } else {
      $(".jsDoExport").remove();
    }
  }

  formatData(s) {
    return s;
  }

  getCollectionNameBello(collectionName) {
    if (collectionName === "FOTOTECA_coll") return "Fototeca";
    if (collectionName === "ARCHIVI_coll") return "Archivi";
    if (collectionName === "APPARECCHI_coll") return "Apparecchi";
    if (collectionName === "MANIFESTI_coll") return "Manifesti";
    if (collectionName === "FILMOGRAFIA_coll") return "Filmografia";
    if (collectionName === "MEMORABILIA_coll") return "Memorabilia";
    if (collectionName === "MISCELLANEA_coll") return "Miscellanea";
    if (collectionName === "CINETECA_coll") return "Cineteca";
    if (collectionName === "ARCHEOLOGIADELCINEMA_coll") return "Archeologia del Cinema";
    return collectionName;
  }

  setFullTextSearch() {
    // jQuery(".js-btn-submit-search").on("click", this.doSearch.bind(this, "guerre stellari", "MANIFESTI_coll", null));
    document.querySelector(".js-btn-submit-search")?.addEventListener("click", () => {
      console.log(this.siteHeader.fullTextData);
      const o = this.siteHeader.fullTextData;
      if (Pqp.isNullOrEmpty(o.field)) {
        o.field = null;
      }
      this.doSearch(o.text, o.collection, o.field);
    });
  }
}
